import { FC } from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Profile } from "../Profile";
import { NoSignal } from "../NoSignal";
import { getAppBarColor } from "./envColor";

interface Props {
  showMenu: boolean;
  onMenu: () => void;
}

export const Header: FC<Props> = ({ showMenu, onMenu }) => {
  const env = import.meta.env.VITE_ENV;

  return (
    <AppBar
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: getAppBarColor(env, theme),
      })}
    >
      <Toolbar>
        {showMenu && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={onMenu}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography variant="h6" noWrap>
          WMS - Infra {env && `(${env})`}
        </Typography>

        <div style={{ flexGrow: 1 }} />
        <NoSignal />
        <Profile />
      </Toolbar>
    </AppBar>
  );
};
